import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CameraIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M29.6305 9.17145C28.7855 8.74892 27.7891 8.83767 27.0341 9.40646C26.9854 9.44271 26.9391 9.48396 26.8966 9.52648L24.7002 11.7429C24.4365 8.53641 21.7738 6 18.5011 6H7.25039C3.80392 5.99875 1 8.80268 1 12.2491V19.7496C1 23.1961 3.80392 26 7.25039 26H18.5011C21.7875 26 24.4615 23.4411 24.704 20.2159L26.8991 22.4085C26.9416 22.4497 26.9854 22.4872 27.0329 22.5235C27.4729 22.8535 27.993 23.0211 28.518 23.0211C28.8968 23.0211 29.2755 22.9347 29.6305 22.7572C30.4769 22.3347 31.0019 21.4835 31.0019 20.5396V11.3916C31.0019 10.4453 30.4769 9.59397 29.6305 9.17145ZM18.5011 23.4999H7.25039C5.18276 23.4999 3.50016 21.8172 3.50016 19.7496V12.2491C3.50016 10.1815 5.18276 8.49891 7.25039 8.49891H18.5011C20.5688 8.49891 22.2514 10.1815 22.2514 12.2491V19.7496C22.2514 21.8172 20.5688 23.4999 18.5011 23.4999ZM24.7515 16.7282V15.2418L28.5017 11.4566L28.533 20.5046L24.7515 16.7282Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
